module.exports = __webpack_public_path__ + "static/media/google.c851c580.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/google.svg
// module id = 887
// module chunks = 0